export const getImage = (item: any) => {
  return item.attributes.image.data.attributes.url;
};
